import { useMemo } from 'react';
import { AnnotationListColumns } from '@rossum/api-client/shared';
import { GridLogicOperator } from '@rossum/ui/x-data-grid-pro';
import { parseAndValidate } from '../../../utils/jsonParse';
import { ValidatedGridFilterItem } from '../../document-list-filtering/types';
import {
  DataGridConditionModel,
  filteringSchema,
} from '../../mql/encodeMqlQuery';
import { validateFilterItems } from '../validate-filter-items/validateFilterItems';

export const useSafelyParsedFiltering = (
  filteringFromQuery: string,
  columns?: AnnotationListColumns
): {
  validFilters: ValidatedGridFilterItem[];
  invalidFilters: ValidatedGridFilterItem[];
  shouldShowParsingError: boolean;
} => {
  const safelyParsedFiltering = useMemo<DataGridConditionModel>(() => {
    // try to parse stored query and validate it against schema
    // return default shape if it is not valid in catch
    return parseAndValidate(filteringFromQuery, filteringSchema, {
      items: [],
      logicOperator: GridLogicOperator.And,
    });
  }, [filteringFromQuery]);

  const shouldShowParsingError = Boolean(
    !safelyParsedFiltering.items.length && filteringFromQuery.length
  );

  if (columns) {
    return {
      ...validateFilterItems(columns, safelyParsedFiltering.items),
      shouldShowParsingError,
    };
  }

  return {
    validFilters: safelyParsedFiltering.items.map(f => ({
      ...f,
      isValid: true,
    })),
    invalidFilters: [],
    shouldShowParsingError,
  };
};
